import logo from "@/assets/logo.png";

interface PolicyCoverProps {
  coverUrl?: string | null;
  companyName: string;
  className?: string;
}

const GRADIENTS = [
  ["#7c3aed", "#4f46e5"], // violet → indigo
  ["#f43f5e", "#f97316"], // rose → orange
  ["#10b981", "#06b6d4"], // emerald → cyan
  ["#0ea5e9", "#3b82f6"], // sky → blue
  ["#d946ef", "#8b5cf6"], // fuchsia → purple
  ["#f59e0b", "#f97316"], // amber → orange
  ["#14b8a6", "#10b981"], // teal → emerald
  ["#64748b", "#374151"], // slate → zinc
];

function pickGradient(name: string) {
  const sum = name.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return GRADIENTS[sum % GRADIENTS.length];
}

export function PolicyCover({ coverUrl, companyName, className = "w-full h-full rounded-xl overflow-hidden" }: PolicyCoverProps) {
  if (coverUrl) {
    return (
      <div className={className}>
        <img
          src={coverUrl}
          alt="Policy cover"
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  const [from, to] = pickGradient(companyName || "default");
  const patternId = "cover-dots";

  return (
    <div
      className={`${className} relative`}
      style={{ background: `linear-gradient(135deg, ${from} 0%, ${to} 100%)` }}
    >
      {/* Dot-grid overlay */}
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id={patternId}
            x="0"
            y="0"
            width="20"
            height="20"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="2" cy="2" r="1.5" fill="white" fillOpacity="0.18" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${patternId})`} />
      </svg>

      {/* Subtle noise vignette */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 120%, rgba(0,0,0,0.25) 0%, transparent 70%)",
        }}
      />

      {/* Centered logo */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div
          className="rounded-2xl p-3"
          style={{ background: "rgba(255,255,255,0.15)", backdropFilter: "blur(8px)" }}
        >
          <img
            src={logo}
            alt="Company logo"
            className="w-16 h-16 object-contain"
            style={{ filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.3))" }}
          />
        </div>
      </div>
    </div>
  );
}
